import React from 'react';
import QRCode from "react-qr-code";
import '../less/payment.less';
import logo from '../../../../../assets/logos/logo.svg'
import { URL_APP_STORE, URL_GOOGLE_PLAY } from "../../../../../auxiliary-components/Footer/variables";


export default function template() {
  const { match = {} } = this.props,
    type = match.params && match.params.lastPage;
  const qr = this.state.qr_value && !type ? (
    <QRCode
      className="qr"
      size={200}
      style={{ height: "auto", maxWidth: "100%", width: "100%" }}
      value={this.state.qr_value}
      viewBox={`0 0 256 256`}
      level="M"
    />
  ) : (!this.state.qr_error ? "" : <div className="qr-error" dangerouslySetInnerHTML={{ __html: this.l10n("PAYMENTS_MODAL_QR_ERROR")}}></div>),
  body = this.state.frame_url && !type ?
    (
      <iframe onLoad={(e) => this.iframeLoad(e)} id='frame' src={this.state.frame_url} frameBorder="0" allowFullScreen="allowfullscreen" />
    )
    :
    (
      <div>
        <div className="qr-modal">
          <img className="logo" alt="logo" src={logo}/>
          <div className="qr-text" dangerouslySetInnerHTML={{ __html: type ? this.l10n("PAYMENTS_MODAL_SUCCESS_TEXT") : this.l10n("PAYMENTS_MODAL_QR_TEXT") }}/>
          {qr}
        </div>
        <div className="download-block">
          <div className="icons">
            <a className={"icon app-store"} href={URL_APP_STORE} target="_blank"/>
            <a className={"icon google-play"} href={URL_GOOGLE_PLAY} target="_blank"/>
          </div>
          <div className="disclaimer" dangerouslySetInnerHTML={{ __html: this.l10n("PAYMENTS_MODAL_DOWNLOAD_TEXT") }}/>
        </div>
      </div>
    );
  return (
    <div className="payment-wrapper">
      <div className="content">
        {body}
      </div>
    </div>
  )
}
